import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LogoutButton = () => {
    const { logout } = useAuth0();

    function handleOnClick(e) {
        logout({          
            returnTo: window.location.origin,
        })
    }

    return (
        <button
            className="btn btn-danger btn-block"
            onClick={handleOnClick}
        >
            Log Out
        </button>
    );
};

export default LogoutButton;
